import { initializeApp, getApp, getApps } from "firebase/app";
import { getAnalytics, Analytics } from "firebase/analytics";
import strings from "./../utils/Strings";
import Logger from "../utils/Logger";

const firebaseConfigTesting = {
  //Local firebase testing configuration by srivarshini
  apiKey: "AIzaSyD0EgWz1ewc1OKcrTtsPiaDvp_mX7iMhac",
  authDomain: "flutter-prep-ba749.firebaseapp.com",
  databaseURL: "https://flutter-prep-ba749-default-rtdb.firebaseio.com",
  projectId: "flutter-prep-ba749",
  storageBucket: "flutter-prep-ba749.firebasestorage.app",
  messagingSenderId: "250072412238",
  appId: "1:250072412238:web:1b7700aabec5c63c11531f",
  measurementId: "G-L08L1V2LEW",
};
const firebaseConfigProd = {
  apiKey: "AIzaSyAZztkm4gqJtGFCh6jkP5-03l2JnSrDQZU",
  authDomain: "jozuna.firebaseapp.com",
  projectId: "jozuna",
  storageBucket: "jozuna.appspot.com",
  messagingSenderId: "778765508402",
  appId: "1:778765508402:web:68c71115e9defe3693c12b",
  measurementId: "G-01VNXKP8M2",
};
const firebaseConfigQa = {
  apiKey: "AIzaSyAZztkm4gqJtGFCh6jkP5-03l2JnSrDQZU",
  authDomain: "jozuna.firebaseapp.com",
  projectId: "jozuna",
  storageBucket: "jozuna.appspot.com",
  messagingSenderId: "778765508402",
  appId: "1:778765508402:web:87ec5ff65186fd0a93c12b",
  measurementId: "G-R579D6CS3F",
};
const firebaseConfigDev = {
  apiKey: "AIzaSyAZztkm4gqJtGFCh6jkP5-03l2JnSrDQZU",
  authDomain: "jozuna.firebaseapp.com",
  projectId: "jozuna",
  storageBucket: "jozuna.appspot.com",
  messagingSenderId: "778765508402",
  appId: "1:778765508402:web:6e7cdfb4e5ce682193c12b",
  measurementId: "G-BE77XS12VE",
};

let app;
const environment = process.env.REACT_APP_ENVIORNMENT;

if (getApps().length === 0) {
  //getApps to check the firebase is already initialized or not
  if (environment === strings.environments.dev) {
    app = initializeApp(firebaseConfigDev);
    // app = initializeApp(firebaseConfigTesting);
  } else if (environment === strings.environments.qa) {
    app = initializeApp(firebaseConfigQa);
  } else if (environment === strings.environments.prod) {
    app = initializeApp(firebaseConfigProd);
  } else {
    Logger.info("Environment not configured. Defaulting to Testing.");
    app = initializeApp(firebaseConfigTesting);
  }
} else {
  app = getApp(); //Retrieves the default Firebase app instance if it has already been initialized
}

let analytics: Analytics | null = null;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}
export { analytics };
